import { Button, Select, Switch, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../../atoms/CustomIcons";
import React, { useState } from "react";
// import { useAppSelector } from "../../../../../../../config/hooks";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      type: undefined | string;
      status: undefined | string;
      state: undefined;
      city: undefined;
      onboarding_complete_date: string[] | undefined;
      last_user_activity: string[] | undefined;
      search_text: undefined | string;
    }>
  >;
  filters: {
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    onboarding_complete_date: string[] | undefined;
    last_user_activity: string[] | undefined;
    search_text: undefined | string;
  };
  archived: boolean;
  companyId: string;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters, archived, isArchived } = props;
  const [showFilters, setShowFilters] = useState(false);
  // const clientManagerList = useAppSelector(
  //   (state) => state?.company?.companyClientManager
  // );

  const onChange = (checked: boolean) => {
    isArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      type: undefined,
      status: undefined,
      state: undefined,
      city: undefined,
      onboarding_complete_date: undefined,
      last_user_activity: undefined,
      search_text: undefined,
    });
    isArchived(false);
  };

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search task"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              archived && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Tooltip title="Export the list of tasks">
            <Button icon={<DownloadIcon />} disabled={true} />
          </Tooltip>
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            {/* <div className="filterBox">
              <Tooltip title="Type" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, type: value }))
                  }
                  value={filters?.type}
                  placeholder="Type"
                  options={[
                    {
                      value: "company",
                      label: "Company",
                    },
                    {
                      value: "individual",
                      label: "Individual",
                    },
                  ]}
                />
              </Tooltip>
            </div> */}
            <div className="filterBox">
              <Tooltip title="Service line" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Service line"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Work order" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Work order"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Status" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Status"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Priority" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Priority"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Service" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Service"
                  options={[]}
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                {archived ? "Hide closed" : "Show closed"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={!filters.type && !filters.status}
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
